import { LoginUrlsWrapper } from '../../app/spaces/Login/LoginUrls';
import { Module } from '../Module';
import { ExternalAuthService } from '../services/ExternalAuthService';
import { ServerService } from '../services/ServerService';

export interface ISignedOutScope extends ng.IScope {
  tryAgainLink: string;
}

export class SignedOutCtrl {

  public static $inject = [
    '$scope',
    'ExternalAuthService',
    'ServerService'
  ];

  constructor(
    $scope: ISignedOutScope,
    externalAuthService: ExternalAuthService,
    server: ServerService
  ) {
    $scope.tryAgainLink = server.isAuthenticationExternal() && !(server.isSiteSamlEnabled() && server.isServerDomainFamilyLocal()) ?
      externalAuthService.getLoginUrl({}) :
      LoginUrlsWrapper.getInstance().signinUrl({});
  }

}

Module.instance().controller('SignedOutCtrl', SignedOutCtrl);
